export default __webpack_public_path__ + "static/media/DHL.00ced218.svg";